import { App } from 'app';
import { createRoot } from 'react-dom/client';

const root = document.getElementById('root');

if (!root) throw new Error(`No element with ID 'root'`);

createRoot(root).render(<App />);
